import { type StateType } from '../../../states';
import { type EntitiesOdds } from '../../../states/entities/odds';
import { type Selector } from '../../../types/selectors';
import { getOutcomeIdOrOddsIdFromProps } from '../../_propsGetters_';
import { type GetOutcomeIdOrOddsIdFromPropsType } from '../../_propsGetters_';
import { selectEntitiesState } from '../entitiesPrimary.selector';

const emptyObject = {};

export const selectEntitiesOdds: Selector<EntitiesOdds> = (state: StateType) =>
  selectEntitiesState(state)?.odds ?? emptyObject;

export const selectEntitiesOddsEntity: Selector<number | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => {
  const id = getOutcomeIdOrOddsIdFromProps(state, props);

  if (id) {
    return selectEntitiesOdds(state)[id];
  }
};
